import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/CadastroCliente.css";
import "../styles/CadastroUsuario.css";
import { isValid } from "@fnando/cnpj";

const aplicarMascara = (campo, valor) => {
  switch (campo) {
    case "cnpj":
      const cnpjNumeros = valor.replace(/\D/g, "").slice(0, 14);
      return cnpjNumeros
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d{1,2})$/, "$1-$2");

    case "cep":
      return valor.replace(/\D/g, "").slice(0, 8).replace(/(\d{5})(\d)/, "$1-$2");

    case "telefone":
      const telNumeros = valor.replace(/\D/g, "").slice(0, 11);
      if (telNumeros.length <= 10) {
        return telNumeros
          .replace(/(\d{2})(\d)/, "($1) $2")
          .replace(/(\d{4})(\d)/, "$1-$2");
      } else {
        return telNumeros
          .replace(/(\d{2})(\d)/, "($1) $2")
          .replace(/(\d{5})(\d)/, "$1-$2");
      }

    case "cpf":
      return valor
        .replace(/\D/g, "")
        .slice(0, 11)
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    default:
      return valor;
  }
};


const DetalhesCliente = () => {

  const modalidadesDisponiveis = [
    "Ensino Médio",
    "PJ-RH/T&D",
    "Graduação",
    "Pós-Graduação",
    "Mestrado/Doutorado"
  ];

  const { id } = useParams();
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [formCliente, setFormCliente] = useState({});
  const [formAdmin, setFormAdmin] = useState({});

  useEffect(() => {
    const fetchCliente = async () => {
      try {
        const response = await fetch(`http://localhost:5000/api/clientes/${id}`);
        const data = await response.json();
        if (response.ok) {
          const dadosComMascara = {
            ...data,
            cnpj: aplicarMascara("cnpj", data.cnpj),
            cep: aplicarMascara("cep", data.cep),
            telefone: aplicarMascara("telefone", data.telefone),
            usuario_admin: {
              ...data.usuario_admin,
              telefone: aplicarMascara("telefone", data.usuario_admin?.telefone || "")
            }
          };

    setCliente(dadosComMascara);
    setFormCliente(dadosComMascara);

        } else {
          alert("Cliente não encontrado.");
          navigate("/clientes");
        }
      } catch (error) {
        console.error("Erro ao buscar cliente:", error);
        alert("Erro ao carregar os dados do cliente.");
        navigate("/clientes");
      }
    };

    const fetchAdmin = async () => {
      try {
        const response = await fetch(`http://localhost:5000/api/usuarios?cliente_id=${id}&tipo=Administrador do Cliente`);
        const data = await response.json();
        if (response.ok && Array.isArray(data) && data.length > 0) {
          setAdmin(data[0]);
          setFormAdmin(data[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar usuário administrador:", error);
      } finally {
        setCarregando(false);
      }
    };

    fetchCliente();
    fetchAdmin();
  }, [id, navigate]);

  const handleExcluir = async () => {
    if (!window.confirm("Deseja realmente excluir este cliente?")) return;

    try {
      const response = await fetch(`http://localhost:5000/api/clientes/${id}`, {
        method: "DELETE",
      });

      if (response.ok) {
        alert("Cliente excluído com sucesso.");
        navigate("/clientes");
      } else {
        alert("Erro ao excluir cliente.");
      }
    } catch (error) {
      console.error("Erro ao excluir cliente:", error);
      alert("Erro de conexão.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormCliente((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeAdmin = (e) => {
    const { name, value } = e.target;
    setFormAdmin((prev) => ({ ...prev, [name]: value }));
  };

  const handleSalvar = async () => {
    try {

      const cnpjNumeros = formCliente.cnpj.replace(/\D/g, "");
      if (!formCliente.cnpj || cnpjNumeros.length < 14) {
        alert("CNPJ incompleto.");
        return;
      }
      if (!isValid(formCliente.cnpj)) {
        alert("CNPJ inválido.");
        return;
      }

      const cepNumeros = formCliente.cep.replace(/\D/g, "");
      if (cepNumeros.length < 8) {
        alert("CEP incompleto.");
        return;
      }

      const payloadCliente = {
        ...formCliente,
        modalidades: Array.isArray(formCliente.modalidades)
          ? formCliente.modalidades.join(", ")
          : formCliente.modalidades,
      };

const clienteResponse = await fetch(`http://localhost:5000/api/clientes/${id}`, {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payloadCliente),
});


      const adminResponse = await fetch(`http://localhost:5000/api/usuarios/${formAdmin.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formAdmin),
      });

      if (clienteResponse.ok && adminResponse.ok) {
        alert("Dados atualizados com sucesso.");
        setModoEdicao(false);
        setCliente(formCliente);
        setAdmin(formAdmin);
      } else {
        alert("Erro ao atualizar cliente ou administrador.");
      }
    } catch (error) {
      console.error("Erro ao salvar:", error);
      alert("Erro ao conectar com o servidor.");
    }
  };

  if (carregando || !cliente) return <p>Carregando dados do cliente...</p>;

  return (
    <div className="form-wrapper">

<div className="form-actions">
  <button type="button" className="btn btn-secondary" onClick={() => navigate("/clientes")}>
    Voltar
  </button>

  {modoEdicao ? (
    <>
      <button type="button" className="btn btn-secondary" onClick={() => {
        setModoEdicao(false);
        setFormCliente(cliente);
        setFormAdmin(admin);
      }}>
        Cancelar
      </button>
      <button type="button" className="btn btn-primary" onClick={handleSalvar}>
        Salvar
      </button>
    </>
  ) : (
    <>
      <button type="button" className="btn btn-secondary" onClick={() => setModoEdicao(true)}>
        Editar
      </button>
      <button type="button" className="btn btn-danger" onClick={handleExcluir}>
        Excluir
      </button>
      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => navigate(`/setup-cliente/${id}`)}
      >
        Setup
      </button>
    </>
  )}
</div>



      <h2 className="form-title">Dados do Cliente</h2>

      <div className="form-row">
        <div className="form-group" style={{ width: '160px', flex: 'none' }}>
          <label>CNPJ</label>
         
          <input
            name="cnpj"
            className="input-mask"
            type="text"
            value={formCliente.cnpj}
            onChange={(e) => {
              let somenteNumeros = e.target.value.replace(/\D/g, "").slice(0, 14);
              let comMascara = aplicarMascara("cnpj", somenteNumeros);
              setFormCliente((prev) => ({ ...prev, cnpj: comMascara }));
            }}
            disabled={!modoEdicao}
          />

        </div>
        <div className="form-group">
          <label>Nome Fantasia</label>
          <input name="nome_fantasia" type="text" value={formCliente.nome_fantasia || ""} onChange={handleChange} disabled={!modoEdicao} />
        </div>
      </div>

      <div className="form-group form-group-full">
        <label>Razão Social</label>
        <input name="razao_social" type="text" value={formCliente.razao_social} onChange={handleChange} disabled={!modoEdicao} />
      </div>

      <div className="form-group section-title">
        <label>Modalidades</label>
      </div>
      <div className="checkbox-group">
        
        {modalidadesDisponiveis.map((mod, index) => (
          <label key={index}>
            <input
              type="checkbox"
              checked={formCliente.modalidades?.includes(mod)}
              disabled={!modoEdicao}
              onChange={(e) => {
                const selected = formCliente.modalidades?.split(",").map(s => s.trim()) || [];
                const atualizadas = e.target.checked
                  ? [...selected, mod]
                  : selected.filter(m => m !== mod);
                setFormCliente((prev) => ({
                  ...prev,
                  modalidades: atualizadas.join(", "),
                }));
              }}
            />{" "}
            {mod}
          </label>
        ))}


      </div>

      <hr className="form-divider" />

      <div className="form-row cep-row">
        <div className="form-group" style={{ width: '110px', flex: 'none' }}>
          <label>CEP</label>

          <input
            name="cep"
            type="text"
            className="input-mask"
            value={formCliente.cep}
            onChange={(e) => {
              const valor = aplicarMascara("cep", e.target.value);
              setFormCliente((prev) => ({ ...prev, cep: valor }));
            }}
            disabled={!modoEdicao}
          />

        </div>
        <div className="form-group" style={{ flex: 1 }}>
          <label>Cidade</label>
          <input name="cidade" type="text" value={formCliente.cidade} onChange={handleChange} disabled={!modoEdicao} />
        </div>
        <div className="form-group" style={{ width: '65px', flex: 'none' }}>
          <label>UF</label>
          <input name="uf" type="text" value={formCliente.uf} onChange={handleChange} disabled={!modoEdicao} />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group" style={{ flex: 1 }}>
          <label>Endereço</label>
          <input name="endereco" type="text" value={formCliente.endereco} onChange={handleChange} disabled={!modoEdicao} />
        </div>
        <div className="form-group" style={{ width: '80px', flex: 'none' }}>
          <label>Número</label>
          <input name="numero" type="text" value={formCliente.numero} onChange={handleChange} disabled={!modoEdicao} />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group" style={{ width: '160px', flex: 'none' }}>
          <label>Telefone</label>

          <input
            name="telefone"
            type="text"
            className="input-mask"
            value={formCliente.telefone}
            onChange={(e) => {
              const valor = aplicarMascara("telefone", e.target.value);
              setFormCliente((prev) => ({ ...prev, telefone: valor }));
            }}
            disabled={!modoEdicao}
          />

        </div>
        <div className="form-group">
          <label>Website</label>
          <input name="website" type="text" value={formCliente.website} onChange={handleChange} disabled={!modoEdicao} />
        </div>
      </div>

      {admin && (
        <>
          <hr className="form-divider" />
          <h2 className="form-title">Administrador do Cliente</h2>

          <div className="form-row">
            <div className="form-group" style={{ width: '160px', flex: 'none' }}>
              <label>CPF</label>
              <input
                name="cpf"
                className="input-mask"
                type="text"
                value={formAdmin.cpf || ""}
                onChange={(e) => {
                  const valor = aplicarMascara("cpf", e.target.value);
                  setFormAdmin((prev) => ({ ...prev, cpf: valor }));
                }}
                disabled={!modoEdicao}
              />

            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Nome Completo</label>
              <input name="nome_completo" type="text" value={formAdmin.nome_completo || ""} onChange={handleChangeAdmin} disabled={!modoEdicao} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group" style={{ width: '210px', flex: 'none' }}>
              <label>Gênero</label>
            
              <select
                name="genero"
                value={formAdmin.genero || ""}
                onChange={handleChangeAdmin}
                disabled={!modoEdicao}
              >
                <option value="">Selecione...</option>
                <option value="Masculino">Masculino</option>
                <option value="Feminino">Feminino</option>
                <option value="Não Binário">Não Binário</option>
                <option value="Prefiro não informar">Prefiro não informar</option>
              </select>

            </div>
            <div className="form-group" style={{ width: '160px', flex: 'none' }}>
              <label>Data de Nascimento</label>
              <input name="data_nascimento" type="date" value={formAdmin.data_nascimento || ""} onChange={handleChangeAdmin} disabled={!modoEdicao} />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Cargo/Função</label>
              <input name="cargo" type="text" value={formAdmin.cargo || ""} onChange={handleChangeAdmin} disabled={!modoEdicao} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group" style={{ width: '180px', flex: 'none' }}>
              <label>Telefone</label>
              <input
                name="telefone"
                className="input-mask"
                type="text"
                value={formAdmin.telefone || ""}
                onChange={(e) => {
                  const valor = aplicarMascara("telefone", e.target.value);
                  setFormAdmin((prev) => ({ ...prev, telefone: valor }));
                }}
                disabled={!modoEdicao}
              />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Email</label>
              <input name="email" type="text" value={formAdmin.email || ""} onChange={handleChangeAdmin} disabled={!modoEdicao} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group" style={{ width: '220px', flex: 'none' }}>
              <label>Usuário (login)</label>
              <input name="usuario" type="text" value={formAdmin.usuario || ""} onChange={handleChangeAdmin} disabled={!modoEdicao} />
            </div>
            <div className="form-group" style={{ width: '220px', flex: 'none' }}>
              <label>Tipo de Usuário</label>
              <input name="tipo" type="text" value={formAdmin.tipo || ""} onChange={handleChangeAdmin} disabled={!modoEdicao} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DetalhesCliente;